import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import DisputeMerchandiseReasonPage from "components/pages/DisputeTransactionPages/DisputeMerchandiseReasonPage";
import DisputeMerchandiseReasonView, { getDefaultData, getDefaultUI } from "components/pages/DisputeTransactionPage/components/DisputeMerchandiseReasonView";

export default function CaptureDisputeReturnMethodDD(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
        const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .update(["dispute", "whatAreYouTryingToDispute"], "merchandise")
    .update(["dispute", "whatDidYouPurchase"], "Nike Air Force 1 `07 White / Action Green Women's Shoes")
    .update(["dispute", "wasTheMerchandiseDeliveredElectronically"], "no")
    .update(["dispute", "whyAreYouDissatisfiedWithTheMerchandise"], "The sneakers were dirty and looked like they had been worn already.")
    .update(["dispute", "didYouReturnTheMerchandise"], "yes")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["howDidYouReturnTheMerchandiseCustomSelectIsActive"], true)
    .submit();
    return (
        <DisputeMerchandiseReasonPage data={ data } ui={ ui }/>
    );
}